import { STOP_TOOLTIP_CONFIG } from 'react/utils/stopUtils';

const { stopDetailsPopup } = window.actions;

Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.GeocodeStop = function (routeId, map) {

    this.position = {};
    this.stop = null;

    this.setCorrectLocation = function (latitude, longitude) {

        this.position.latitude = latitude;
        this.position.longitude = longitude;

        return this;
    };

    this.setStop = function (stop) {
        this.stop = stop;
        return this;
    };

    this.createIcon = function (contentToIcon) {
      const div = document.createElement('div');

      div.innerHTML = `
        <div class="markerRouteStops">
          <div class="spaceText REPROCESSED">
            <div>
              ${contentToIcon}
            </div>
          </div>
        </div>
      `;

      return div.innerHTML;
    };

    this.removeGeocodedPosition = function (stopID) {
        const layers = map._layers;
        const stopId = stopID || this.stop.id;

        const markerLayerType = `correctPosition_${stopId}`;
        const polylineType = `correctPolylinePosition_${stopId}`;

        for (const key in layers) {
            const layer = layers[key];

            if (layer.type && (layer.type === markerLayerType || layer.type === polylineType)) {
                map.removeLayer(layer);
            }
        }

        return this;

    };

    this.createMarker = function (contentToIcon) {
        const icon = this.createIconLocation(contentToIcon);
        const marker = new L.marker([this.position.latitude, this.position.longitude], {
            icon: icon,
            clickable: false
        });

        marker.kind = "STOP";
        marker.type = "correctPosition_" + this.stop.id;

        return marker;
    };

    this.renderMarkerAndOpenPopup = function () {
        const position = this.position;
        const newPosition = [position.latitude, position.longitude];
        const lat = this.stop.latitude || this.stop.location.latitude;
        const lng = this.stop.longitude || this.stop.location.longitude;
        const latLongStop = [lat, lng];
        const textToIcon = Monet.Session.RouteDetail.screensList[routeId].editingStop.marker.options.icon.options.content;
        const marker = this.createMarker(textToIcon);
        const popupTGeocode = new Greenmile.RouteDetail.PopupToGeocode(routeId, marker, this.stop.id);

        this.removeGeocodedPosition();
        popupTGeocode.setPositionToSave(this.position);

        popupTGeocode.setClickActionToCancel(function (context) {
            return function () {
                context.removeGeocodedPosition();
                context.renderMarkerGeocoded();
                popupTGeocode.afterActions();
                const stopId = context.stop.id;
                window.GreenmileReduxStore.dispatch(stopDetailsPopup.disableGeocode(routeId, stopId));
            };
        }(this));

        popupTGeocode.setCallbackToSaveAndReprocess(function () {
            Greenmile.Map.Utility.removeLayerByKind(map, ['STOP_SUGGESTIONS']);
            popupTGeocode.getAutoArriveConfigurationAndRenderPopupInfoToReprocess();
        });
        marker
          .bindTooltip(
            Monet.I18n.getResourcesByKey('RouteDetail.stopMarker.tooltip.geocodedStop'),
            STOP_TOOLTIP_CONFIG
          )
          .on('mouseover', () => marker.openTooltip())
          .on('mouseout', () => marker.closeTooltip());
        marker.addTo(map).bindPopup(popupTGeocode.render(newPosition, latLongStop), {
            offset: new L.Point(48, 2),
            className: 'geocode-popup',
            maxWidth: 600
        }).openPopup();

        this.drawPolyline(latLongStop, newPosition);

    };

    this.drawPolyline = function (latLngInit, latLngEnd) {
        const polyline = L.polyline([latLngInit, latLngEnd], {
            color: '#000000',
            weight: 2
        });

        polyline.type = "correctPolylinePosition_" + this.stop.id;
        polyline.kind = "POLYLINE_STOP";
        polyline.addTo(map);
    };

    this.createIconLocation = function (contentToIcon) {

        var that = this;

        return L.divIcon({
            className: 'greenmileMarkerIcon',
            iconSize: null,
            html: that.createIcon(contentToIcon)
        });

    };

    this.setNewMarker = function (stop, marker) {

        var isStopLocationLat = ( typeof stop.location.latitude !== "undefined" ) ? true : false,
            isStopLocationLng = ( typeof stop.location.longitude !== "undefined" ) ? true : false,
            isStopLat         = ( typeof stop.latitude !== "undefined" ) ? true : false,
            isStopLng         = ( typeof stop.longitude !== "undefined" ) ? true : false;

        if ( (isStopLocationLat && isStopLocationLng) || (isStopLat && isStopLng) ) {

            Monet.Session.RouteDetail.screensList[routeId].editingStop = {
                stop: stop,
                marker: marker,
                routeId: routeId,
                isSetPosition: true
            };

            Monet.Session.RouteDetail.screensList[routeId].isUpdateAutomatic = false;

        }

    };

    this.renderMarkerGeocoded = function () {
        const stop = this.stop;

        if (stop.location &&
            stop.latitude &&
            stop.longitude &&
            stop.location.latitude !== stop.latitude && stop.location.longitude !== stop.longitude) {

            const textToIcon = Monet.Session.RouteDetail.screensList[routeId].editingStop.marker.options.icon.options.content;
            this.setCorrectLocation(stop.location.latitude, stop.location.longitude).createMarker(textToIcon).addTo(map);
            this.drawPolyline([stop.latitude, stop.longitude], [stop.location.latitude, stop.location.longitude]);
        }
    };

};
